import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "name", "alternateBackground", "background", "backgroundColor", "children"];
import "core-js/modules/es.function.name.js";
import React, { forwardRef } from 'react';
import Box from 'components/Box';
import ThemeSection from 'components/ThemeSection';
export var ThemedBox = /*#__PURE__*/forwardRef(function (props, ref) {
  var as = props.as,
    name = props.name,
    alternateBackground = props.alternateBackground,
    background = props.background,
    backgroundColor = props.backgroundColor,
    children = props.children,
    otherProps = _objectWithoutProperties(props, _excluded);
  var getAutomaticBgColor = function getAutomaticBgColor(theme) {
    return alternateBackground && theme.backgroundAlt ? theme.backgroundAlt : theme.background;
  };
  return /*#__PURE__*/React.createElement(ThemeSection, {
    name: name
  }, /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: as || 'div'
  }, otherProps, {
    textColor: "text",
    backgroundColor: background || backgroundColor || getAutomaticBgColor
  }), children));
});
ThemedBox.displayName = 'ThemedBox';
export default ThemedBox;